/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetReadyTemplateByIdDto } from '../models/custom-result-of-get-ready-template-by-id-dto';
import { CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-ready-templates-with-pagination-dto';
import { readyTemplatesCopy } from '../fn/ready-templates/ready-templates-copy';
import { ReadyTemplatesCopy$Params } from '../fn/ready-templates/ready-templates-copy';
import { readyTemplatesCreateGet } from '../fn/ready-templates/ready-templates-create-get';
import { ReadyTemplatesCreateGet$Params } from '../fn/ready-templates/ready-templates-create-get';
import { readyTemplatesCreatePost } from '../fn/ready-templates/ready-templates-create-post';
import { ReadyTemplatesCreatePost$Params } from '../fn/ready-templates/ready-templates-create-post';
import { readyTemplatesDelete } from '../fn/ready-templates/ready-templates-delete';
import { ReadyTemplatesDelete$Params } from '../fn/ready-templates/ready-templates-delete';
import { readyTemplatesGetReadyTemplatesWithPagination } from '../fn/ready-templates/ready-templates-get-ready-templates-with-pagination';
import { ReadyTemplatesGetReadyTemplatesWithPagination$Params } from '../fn/ready-templates/ready-templates-get-ready-templates-with-pagination';
import { readyTemplatesUpdateGet } from '../fn/ready-templates/ready-templates-update-get';
import { ReadyTemplatesUpdateGet$Params } from '../fn/ready-templates/ready-templates-update-get';
import { readyTemplatesUpdatePut } from '../fn/ready-templates/ready-templates-update-put';
import { ReadyTemplatesUpdatePut$Params } from '../fn/ready-templates/ready-templates-update-put';

@Injectable({ providedIn: 'root' })
export class ReadyTemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `readyTemplatesCreateGet()` */
  static readonly ReadyTemplatesCreateGetPath = '/ReadyTemplates/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyTemplatesCreateGet$Response(params?: ReadyTemplatesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return readyTemplatesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyTemplatesCreateGet(params?: ReadyTemplatesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.readyTemplatesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `readyTemplatesCreatePost()` */
  static readonly ReadyTemplatesCreatePostPath = '/ReadyTemplates/Create';

  /**
   * ساخت قالب آماده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesCreatePost$Response(params: ReadyTemplatesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return readyTemplatesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ساخت قالب آماده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesCreatePost(params: ReadyTemplatesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.readyTemplatesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `readyTemplatesUpdateGet()` */
  static readonly ReadyTemplatesUpdateGetPath = '/ReadyTemplates/Update';

  /**
   * Get ReadyTemplate ById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyTemplatesUpdateGet$Response(params?: ReadyTemplatesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetReadyTemplateByIdDto>> {
    return readyTemplatesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ReadyTemplate ById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyTemplatesUpdateGet(params?: ReadyTemplatesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetReadyTemplateByIdDto> {
    return this.readyTemplatesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetReadyTemplateByIdDto>): CustomResultOfGetReadyTemplateByIdDto => r.body)
    );
  }

  /** Path part for operation `readyTemplatesUpdatePut()` */
  static readonly ReadyTemplatesUpdatePutPath = '/ReadyTemplates/Update';

  /**
   * به روز رسانی قالب آماده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesUpdatePut$Response(params: ReadyTemplatesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return readyTemplatesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی قالب آماده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesUpdatePut(params: ReadyTemplatesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.readyTemplatesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `readyTemplatesDelete()` */
  static readonly ReadyTemplatesDeletePath = '/ReadyTemplates/Delete';

  /**
   * حذف قالب آماده.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesDelete$Response(params: ReadyTemplatesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return readyTemplatesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف قالب آماده.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesDelete(params: ReadyTemplatesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.readyTemplatesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `readyTemplatesCopy()` */
  static readonly ReadyTemplatesCopyPath = '/ReadyTemplates/Copy';

  /**
   * کپی قالب آماده برای سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesCopy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesCopy$Response(params: ReadyTemplatesCopy$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return readyTemplatesCopy(this.http, this.rootUrl, params, context);
  }

  /**
   * کپی قالب آماده برای سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesCopy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesCopy(params: ReadyTemplatesCopy$Params, context?: HttpContext): Observable<CustomResult> {
    return this.readyTemplatesCopy$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `readyTemplatesGetReadyTemplatesWithPagination()` */
  static readonly ReadyTemplatesGetReadyTemplatesWithPaginationPath = '/ReadyTemplates/GetReadyTemplatesWithPagination';

  /**
   * لیست قالب آماده های سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyTemplatesGetReadyTemplatesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesGetReadyTemplatesWithPagination$Response(params: ReadyTemplatesGetReadyTemplatesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto>> {
    return readyTemplatesGetReadyTemplatesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست قالب آماده های سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyTemplatesGetReadyTemplatesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  readyTemplatesGetReadyTemplatesWithPagination(params: ReadyTemplatesGetReadyTemplatesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto> {
    return this.readyTemplatesGetReadyTemplatesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto>): CustomResultOfPaginatedListOfGetReadyTemplatesWithPaginationDto => r.body)
    );
  }

}
